(() => {
  const bindTabs = (root) => {
    if (root.dataset.ah2Bound === 'true') return;
    root.dataset.ah2Bound = 'true';
    const tabs = [...root.querySelectorAll('[data-ah2-tab]')];
    const panels = [...root.querySelectorAll('[data-ah2-panel]')];
    if (!tabs.length) return;

    const activate = (tab, focus = false) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.ah2Panel !== tab.dataset.ah2Tab;
      });

      if (focus) tab.focus();
    };

    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-ah2-tab]');
      if (tab) activate(tab);
    });
    root.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-ah2-tab]');
      if (!tab) return;
      const index = tabs.indexOf(tab);
      let next = index;
      if (event.key === 'ArrowRight') next = (index + (getComputedStyle(root).direction === 'rtl' ? -1 : 1) + tabs.length) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - (getComputedStyle(root).direction === 'rtl' ? -1 : 1) + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      activate(tabs[next], true);
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ah2-tabs]').forEach(bindTabs);
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
